<template>
  <div class="icon">
    <svg
      width="36"
      height="31"
      viewBox="0 0 36 31"
      fill=""
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.9062 13.5239V3.64362C31.9062 1.63452 30.2503 0 28.2149 0H7.7851C5.74969 0 4.09389 1.63452 4.09389 3.64362V13.5239C1.74854 14.0808 0 16.1676 0 18.651V26.0205C0 26.6052 0.480166 27.0791 1.07248 27.0791H4.09382V29.6395C4.09382 30.2242 4.57399 30.6981 5.1663 30.6981C5.75862 30.6981 6.23878 30.2242 6.23878 29.6395V27.0791H29.7612V29.6395C29.7612 30.2242 30.2414 30.6981 30.8337 30.6981C31.426 30.6981 31.9062 30.2242 31.9062 29.6395V27.0791H34.9275C35.5198 27.0791 36 26.6052 36 26.0205V18.651C36.0001 16.1676 34.2516 14.0808 31.9062 13.5239ZM6.23885 3.64362C6.23885 2.80203 6.93256 2.1173 7.7851 2.1173H28.215C29.0676 2.1173 29.7613 2.80203 29.7613 3.64362V13.3769H26.2172V11.7068C26.2172 8.93967 23.9364 6.68849 21.1331 6.68849H14.8671C12.0638 6.68849 9.78311 8.93974 9.78311 11.7068V13.3768H6.23885V3.64362ZM24.0722 11.7068V13.3768H11.9279V11.7068C11.9279 10.1071 13.2464 8.80572 14.867 8.80572H21.1331C22.7536 8.80565 24.0722 10.1072 24.0722 11.7068ZM2.14496 24.9619V18.651C2.14496 16.9103 3.57969 15.4941 5.34321 15.4941H30.6568C32.4203 15.4941 33.855 16.9103 33.855 18.651V24.9619H2.14496Z"
        fill="#fff"
      />
    </svg>
    <svg
      width="36"
      height="31"
      viewBox="0 0 36 31"
      fill=""
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.9062 13.5239V3.64362C31.9062 1.63452 30.2503 0 28.2149 0H7.7851C5.74969 0 4.09389 1.63452 4.09389 3.64362V13.5239C1.74854 14.0808 0 16.1676 0 18.651V26.0205C0 26.6052 0.480166 27.0791 1.07248 27.0791H4.09382V29.6395C4.09382 30.2242 4.57399 30.6981 5.1663 30.6981C5.75862 30.6981 6.23878 30.2242 6.23878 29.6395V27.0791H29.7612V29.6395C29.7612 30.2242 30.2414 30.6981 30.8337 30.6981C31.426 30.6981 31.9062 30.2242 31.9062 29.6395V27.0791H34.9275C35.5198 27.0791 36 26.6052 36 26.0205V18.651C36.0001 16.1676 34.2516 14.0808 31.9062 13.5239ZM6.23885 3.64362C6.23885 2.80203 6.93256 2.1173 7.7851 2.1173H28.215C29.0676 2.1173 29.7613 2.80203 29.7613 3.64362V13.3769H26.2172V11.7068C26.2172 8.93967 23.9364 6.68849 21.1331 6.68849H14.8671C12.0638 6.68849 9.78311 8.93974 9.78311 11.7068V13.3768H6.23885V3.64362ZM24.0722 11.7068V13.3768H11.9279V11.7068C11.9279 10.1071 13.2464 8.80572 14.867 8.80572H21.1331C22.7536 8.80565 24.0722 10.1072 24.0722 11.7068ZM2.14496 24.9619V18.651C2.14496 16.9103 3.57969 15.4941 5.34321 15.4941H30.6568C32.4203 15.4941 33.855 16.9103 33.855 18.651V24.9619H2.14496Z"
        fill="#fff"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "TwoBedIcon"
};
</script>

<style lang="sass" scoped>
@import "./src/assets/style/vars"

.icon
  width: 2.5rem
  height: 2.5rem
  background-color: $prime
  display: flex
  justify-content: center
  align-items: center
  border-radius: 50%
  svg
    fill: white
    width: 35%
    height: 35%
    margin-right: 3px
</style>
